// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{background:#dedede}.page-wrap{min-height:100vh}.sub-text{font-size:14px;font-style:italic}.error-link{font-size:26px}.error-reference{font-family:\"Courier New\",Courier,monospace;font-size:14px;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
